
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post-affiliate-pro-alternative",
      function () {
        return require("private-next-pages/post-affiliate-pro-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post-affiliate-pro-alternative"])
      });
    }
  